import React from 'react';
import {Stack, styled} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import {getDeliverableKindLabel} from '@/config/deliverableKinds';
import {type GigDeliverableChange} from '@/types/negotiationSnapshot';

const ValuesRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'baseline',
  gap: '6px',
  flexWrap: 'wrap',
});

function GigDeliverableChangeRow({
  change,
  networkPrettyName,
}: {
  change: GigDeliverableChange;
  networkPrettyName?: string | null;
}) {
  const countChanged =
    change.oldRequiredCount !== null &&
    change.oldRequiredCount !== change.newRequiredCount;

  return (
    <ValuesRow>
      <Body size="sm" color={designSystemToken('semantic.fg.primary')}>
        {getDeliverableKindLabel(change.kind, networkPrettyName)}
      </Body>
      {countChanged ? (
        <Body
          size="sm"
          color={designSystemToken('semantic.fg.secondary')}
          sx={{textDecoration: 'line-through'}}
        >
          {change.oldRequiredCount}
        </Body>
      ) : null}
      <Body size="sm" color={designSystemToken('semantic.fg.primary')}>
        {change.newRequiredCount ?? 0}
      </Body>
    </ValuesRow>
  );
}

export default GigDeliverableChangeRow;
